import { IntakeLabelCollection } from '../../entities/intake-label.interface';

export const IesPrimaryAssetLabels: IntakeLabelCollection = {
  assetType: {
    label: 'Asset type (approximate value)',
  },

  personal: {
    label: 'Personal',
    thirdPersonLabel: '<<applicantName>>',
  },
  spouse: {
    label: 'Spouse/Partner',
    thirdPersonLabel: '<<spouseName>>',
  },
  hasPrimaryAssets: {
    spousePartnerLabel:
      'You have not shared any asset information. Do you or your <<spouseLabel>> have any of the above assets?',
    label: 'You have not shared any asset information. Do you have any of the above assets?',
  },
};
